import { createRouter, createWebHistory } from 'vue-router'

import websiteLayout from '@/website/layouts/LayoutOne.vue'

// Layouts
import adminRoutes from './admin'

const routes = [
    ...adminRoutes,

    {
        path: '/',
        name: 'HomePage',
        component: () => import('@/website/pages/HomePage'),
        meta: { layout: websiteLayout }
    },
    {
        path: '/products',
        name: 'ProductsPage',
        component: () => import('@/website/pages/ProductsPage'),
        meta: { layout: websiteLayout }
    },
    {
        path: '/products/:id',
        name: 'ProductDetailsPage',
        component: () => import('@/website/pages/ProductDetailsPage'),
        meta: { layout: websiteLayout }
    },
    {
        path: '/about',
        name: 'AboutPage',
        component: () => import('@/website/pages/AboutPage'),
        meta: { layout: websiteLayout }
    },
    {
        path: '/contact',
        name: 'ContactPage',
        component: () => import('@/website/pages/ContactPage'),
        meta: { layout: websiteLayout }
    },
    {
        path: '/checkout',
        name: 'CheckOut',
        component: () => import('@/website/pages/CheckOut'),
        meta: { layout: websiteLayout }
    }
]

var router = createRouter({
    history: createWebHistory('/'),
    routes
})


function isLoggedIn()
{
    return localStorage.getItem('token')
}

router.beforeEach((to, from, next) => {
   if(to.matched.some(record => record.meta.requiresAuth)) {
     if(!isLoggedIn()) {
        next({
            name: 'LoginPage'
        })
     } else {
        next()
     }
   } else if(to.matched.some(record => record.meta.isAuthenticated)) {
     if(isLoggedIn()) {
        next({
            name: 'dashboardPage'
        })
     } else {
        next()
     }
   } else {
     next()
   }
})

export default router